module.exports = __webpack_public_path__ + "img/daniel.19122e1d.png";